import { render, staticRenderFns } from "./ChangeSiteDialog.vue?vue&type=template&id=a165187c"
import script from "./ChangeSiteDialog.vue?vue&type=script&lang=js"
export * from "./ChangeSiteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports